import { render } from "./MyAccountPageV2.vue?vue&type=template&id=526e27a8&scoped=true"
import script from "./MyAccountPageV2.vue?vue&type=script&lang=js"
export * from "./MyAccountPageV2.vue?vue&type=script&lang=js"

import "./MyAccountPageV2.vue?vue&type=style&index=0&id=526e27a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526e27a8"]])

export default __exports__